export const SCREENS = {
  AUTH: 'AUTH',
  MENU: 'MENU',
  FIELD_SELECT: 'FIELD_SELECT',
  HOT_SEAT_INIT: 'HOT_SEAT_INIT',
  LOBBY_LIST: 'LOBBY_LIST',
  LOBBY: 'LOBBY',
  // Настройка поиска рейтингового матча — перед самим поиском
  RANK_MATCH_SETUP: 'RANK_MATCH_SETUP',
  RANK_MATCH_WAITING: 'RANK_MATCH_WAITING',
  GAME: 'GAME',
  INVENTORY: 'INVENTORY',
  // Коллекция игрока глазами других (из его профиля или из «Лучших
  // коллекций»), только для просмотра
  USER_INVENTORY: 'USER_INVENTORY',
  GLORY_HALL: 'GLORY_HALL',
  BEST_COLLECTIONS: 'BEST_COLLECTIONS',
  SETTINGS: 'SETTINGS',
  ADMIN: 'ADMIN',
  ADMIN_USERS: 'ADMIN_USERS',
  ADMIN_DELETE_USER: 'ADMIN_DELETE_USER',
  ADMIN_USER_PROFILE: 'ADMIN_USER_PROFILE',
  PROFILE: 'PROFILE',
  MATCH_HISTORY: 'MATCH_HISTORY',
  MATCH_DETAILS: 'MATCH_DETAILS',
  PURCHASE_HISTORY: 'PURCHASE_HISTORY',
  CHEST_OPENING_HISTORY: 'CHEST_OPENING_HISTORY',
  DAILY_LOGIN_REWARD_HISTORY: 'DAILY_LOGIN_REWARD_HISTORY',
  USER_PROFILE: 'USER_PROFILE',
  CHANGE_NICKNAME: 'CHANGE_NICKNAME',
  GRANT_CHEST: 'GRANT_CHEST',
  GRANT_ASSETS: 'GRANT_ASSETS',
  GRANT_SKIN: 'GRANT_SKIN',
  GRANT_CRYSTALS: 'GRANT_CRYSTALS',
  GRANT_PREMIUM: 'GRANT_PREMIUM',
  FACTION_PAGE: 'FACTION_PAGE',
  ALL_SKINS: 'ALL_SKINS',
  SHOP: 'SHOP',
  ACKNOWLEDGMENTS: 'ACKNOWLEDGMENTS',
  LICENSE_AGREEMENT: 'LICENSE_AGREEMENT',
  PRIVACY_POLICY: 'PRIVACY_POLICY',
  CONTACTS: 'CONTACTS',
  PARTNER_FORM: 'PARTNER_FORM',
  PARTNER_REGISTRATIONS: 'PARTNER_REGISTRATIONS',
  ADMIN_PARTNERS: 'ADMIN_PARTNERS',
  FRIEND_INVITE: 'FRIEND_INVITE',
  ADMIN_FRIEND_REFERAL_CONFIG: 'ADMIN_FRIEND_REFERAL_CONFIG',
  ADMIN_LOGIN_PROMO: 'ADMIN_LOGIN_PROMO',
  TUTORIAL_MISSIONS: 'TUTORIAL_MISSIONS',
  QUESTS: 'QUESTS',
  CAMPAIGN_MISSIONS: 'CAMPAIGN_MISSIONS',
  RATING_CRYSTALS: 'RATING_CRYSTALS',
  ADMIN_RATING_CRYSTALS: 'ADMIN_RATING_CRYSTALS',
  ADMIN_MODALS_TEST: 'ADMIN_MODALS_TEST',
  ADMIN_GAME_UI_KIT: 'ADMIN_GAME_UI_KIT',
}

export const SCREENS_LOBBY = {
  MAIN: 'MAIN',
  FACTION_SELECT: 'FACTION_SELECT',
  FIELD_SELECT: 'FIELD_SELECT',
}